import { Toast, type ToastComponent } from '@opallabs/lapidary'

export const ExportFailedToast: ToastComponent = (toastProps) => (
  <Toast
    {...toastProps}
    message="The document failed to download. Please try again later."
    title="Failed to Download"
  />
)
